export const CONSENT_STATUS = {
  GRANTED: 'granted',
  DENIED: 'denied',
} as const;

export type ConsentStatus =
  (typeof CONSENT_STATUS)[keyof typeof CONSENT_STATUS];

export interface ConsentSettings {
  adStorage: ConsentStatus;
  adUserData: ConsentStatus;
  adPersonalization: ConsentStatus;
  analyticsStorage: ConsentStatus;
  functionalityStorage: ConsentStatus;
  personalizationStorage: ConsentStatus;
  securityStorage: ConsentStatus;
  waitForUpdate: number;
}

export const CONSENT_EVENT_TYPE = {
  DEFAULT: 'default',
  UPDATE: 'update',
} as const;

export type ConsentEventType =
  (typeof CONSENT_EVENT_TYPE)[keyof typeof CONSENT_EVENT_TYPE];

export const CONSENT_SOURCE = {
  DEFAULT: 'default',
  STORED: 'stored',
  USER: 'user',
} as const;

export type ConsentSource =
  (typeof CONSENT_SOURCE)[keyof typeof CONSENT_SOURCE];

export interface ConsentDataLayerEvent {
  event: ConsentEventType;
  source: ConsentSource;
  ad_storage: ConsentStatus;
  ad_user_data: ConsentStatus;
  ad_personalization: ConsentStatus;
  analytics_storage: ConsentStatus;
  functionality_storage: ConsentStatus;
  personalization_storage: ConsentStatus;
  security_storage: ConsentStatus;
  wait_for_update: number;
}

export interface AnalyticsConfiguration {
  gtmId: string | undefined;
  isAnalyticsEnabled: boolean;
}

export interface ConsentInitializationResult {
  consent: ConsentSettings;
  source: Exclude<ConsentSource, 'user'>;
}
